import React from "react";
import { FaTachometerAlt, FaUsers } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

export default function Sidebar({ collapsed, role }) {
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user")); // fetch logged-in user info

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        {role === "admin" ? (
          <div className="admin-circle">
            {user?.username ? user.username.charAt(0).toUpperCase() : "A"}
          </div>
        ) : (
          <div className="admin-circle">U</div>
        )}
        {!collapsed && <span className="sidebar-title">{user?.username || role}</span>}
      </div>

      <ul>
        {role === "admin" && (
          <li
            onClick={() => navigate("/admin")}
            className={location.pathname === "/admin" ? "active" : ""}
          >
            <FaTachometerAlt />
            {!collapsed && <span>Admin Dashboard</span>}
          </li>
        )}
        {role === "user" && (
          <li
            onClick={() => navigate("/user")}
            className={location.pathname === "/user" ? "active" : ""}
          >
            <FaTachometerAlt />
            {!collapsed && <span>User Dashboard</span>}
          </li>
        )}
        {role === "admin" && (
          <li
            onClick={() => navigate("/admin/user-manager")}
            className={location.pathname === "/admin/user-manager" ? "active" : ""}
          >
            <FaUsers />
            {!collapsed && <span>User Management</span>}
          </li>
        )}
      </ul>
    </div>
  );
}
